module.exports = __webpack_public_path__ + "static/media/Slide-06.c9bfdf15.jpg";